// Per-platform context for the /reviews/<source> SEO deep-link pages.
// Each block is hand-written, mentions the verified counts/ratings from
// REVIEW_SOURCES, and naturally cross-links to /reviews and the other
// platforms.

export const REVIEW_SOURCE_CONTENT = {
    google: {
        slug: "google",
        sourceName: "Google",
        kicker: "Google Reviews",
        title: "Google Reviews of Reformity Inc.",
        introHeading: "Why we have so many Google reviews",
        intro:
            "Reformity Inc. has earned a 5.0-star rating across 14 Google reviews from homeowners around the GTA — verified through real Google profile activity. Google reviews carry extra weight because they're tied to real Google accounts, can't be deleted by businesses, and feed directly into our Google Business Profile and Maps visibility. Read all 14 verified Google reviews below — or browse our 157 total verified reviews across Homestars, Bark, Houzz, and BBB.",
    },
    homestars: {
        slug: "homestars",
        sourceName: "Homestars",
        kicker: "Homestars Reviews",
        title: "Homestars Reviews of Reformity Inc.",
        introHeading: "Why we have so many Homestars reviews",
        intro:
            "Homestars is Canada's largest verified contractor directory, and Reformity Inc. holds a 4.7-star rating across 35 Homestars reviews — every one of them moderated against project records before publishing. Homestars matters in the GTA because almost every homeowner cross-checks contractors there before signing a contract. See all 35 Homestars reviews below, or compare with our reviews on Bark, Houzz, BBB, and Google or the full 157-review summary on /reviews.",
    },
    bark: {
        slug: "bark",
        sourceName: "Bark",
        kicker: "Bark Reviews",
        title: "Bark Reviews of Reformity Inc.",
        introHeading: "Why we have so many Bark reviews",
        intro:
            "Reformity Inc. is a Bark Certified Pro with a 5.0-star rating across 100 Bark reviews — our largest single-platform review volume. Bark only opens review submissions to homeowners who actually hired a pro through their network, which keeps the feedback honest and recent (most of ours are from the last 18 months). Browse all 100 Bark reviews below, or see how we stack up on Homestars, Houzz, BBB, and Google on the main /reviews page.",
    },
    houzz: {
        slug: "houzz",
        sourceName: "Houzz",
        kicker: "Houzz Reviews",
        title: "Houzz Reviews of Reformity Inc.",
        introHeading: "Why we have so many Houzz reviews",
        intro:
            "Reformity Inc. is a verified Houzz Pro with a 5.0-star rating on the platform. Houzz is the go-to place where homeowners plan deck, fence, and outdoor projects with mood boards and budget tools, so a profile there matters for design-minded clients. Read our verified Houzz reviews below, or browse the full 157-review picture on /reviews along with Homestars, Bark, BBB, and Google.",
    },
    bbb: {
        slug: "bbb",
        sourceName: "BBB",
        kicker: "BBB Reviews & Accreditation",
        title: "BBB Reviews of Reformity Inc.",
        introHeading: "Why we have so many BBB reviews",
        intro:
            "Reformity Inc. is BBB Accredited with an A+ rating and a 5.0-star average across 7 verified BBB customer reviews. BBB accreditation requires meeting and re-confirming a strict set of business standards each year — it's a credibility check we renew on purpose, because Brampton-area homeowners specifically look for that A+ badge before they pick a contractor. Read all of our BBB reviews below, or compare with Homestars, Bark, Houzz, and Google on /reviews.",
    },
};

export const REVIEW_SOURCE_SLUGS = Object.keys(REVIEW_SOURCE_CONTENT);
